/* BalkanTuning – ъпсел „Добави към поръчката“ в side cart-а.
   Източници: ръчно избрани, последно видяни, сходни (Shopify recommendations), колекция.
   Настройки: секция „BT · Ъпсел в количката“ (Header group) → <script id="bt-upsell-config">.
   Добавянето в количката минава през [data-bt-add] в bt-premium.js. */
(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var KEY = 'bt_recent_products';
  var cache = {};

  /* ---------- последно видяни: записваме продуктовата страница ---------- */
  try {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    var isProduct = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    if (m && isProduct) {
      var h = decodeURIComponent(m[1]);
      var list = JSON.parse(localStorage.getItem(KEY) || '[]').filter(function (x) { return x !== h; });
      list.unshift(h);
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12)));
    }
  } catch (e) {}

  function recent() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function cfg() {
    var el = document.getElementById('bt-upsell-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function money(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  function img(u) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=300';
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* product.js / recommendations → общ формат */
  function norm(p) {
    if (!p) return null;
    if (p.variant !== undefined && p.image !== undefined) return p; // вече е от конфигурацията
    var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
    return { id: p.id, handle: p.handle, title: p.title, url: p.url || (ROOT + 'products/' + p.handle),
      price: p.price, compare: p.compare_at_price || 0, image: p.featured_image, available: p.available, variant: v && v.id };
  }
  function byHandle(h) {
    if (cache[h]) return Promise.resolve(cache[h]);
    return fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { cache[h] = norm(p); return cache[h]; }).catch(function () { return null; });
  }
  function related(pid) {
    var k = 'rel_' + pid;
    if (cache[k]) return Promise.resolve(cache[k]);
    return fetch(ROOT + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { cache[k] = (j.products || []).map(norm); return cache[k]; }).catch(function () { return []; });
  }

  function source(c, mode, ctx) {
    if (mode === 'manual') return Promise.resolve(c.manual || []);
    if (mode === 'collection') return Promise.resolve(c.collection || []);
    if (mode === 'recent') {
      var hs = recent().filter(function (h) { return ctx.handles.indexOf(h) === -1; }).slice(0, 8);
      return Promise.all(hs.map(byHandle));
    }
    if (mode === 'related') {
      return Promise.all(ctx.ids.slice(0, 2).map(related)).then(function (a) { return [].concat.apply([], a); });
    }
    // auto: последно видяни → сходни → ръчно избрани
    return Promise.all([source(c, 'recent', ctx), source(c, 'related', ctx)])
      .then(function (a) { return a[0].concat(a[1], c.manual || []); });
  }

  function pick(list, ctx, limit) {
    var seen = {}, out = [];
    list.forEach(function (p) {
      if (!p || !p.available || !p.variant || seen[p.id] || ctx.ids.indexOf(String(p.id)) > -1) return;
      seen[p.id] = 1; out.push(p);
    });
    return out.slice(0, limit);
  }

  function render(el) {
    var c = cfg();
    if (!c) { el.remove(); return; }
    el.setAttribute('data-bt-ready', '1');
    var ctx = {
      ids: (el.dataset.products || '').split(',').filter(Boolean),
      handles: (el.dataset.handles || '').split(',').filter(Boolean)
    };
    var total = Number(el.dataset.total || 0);
    var limit = Number(c.limit) || 6;

    source(c, c.mode, ctx).then(function (list) {
      var items = pick(list, ctx, limit);
      if (!items.length && c.mode !== 'manual') items = pick(c.manual || [], ctx, limit);
      if (!items.length) { el.innerHTML = ''; return; }

      var hint = '';
      var left = (c.goal || 0) - total;
      if (c.hint && left > 0) {
        var fit = items.filter(function (p) { return p.price >= left; }).sort(function (a, b) { return a.price - b.price; })[0];
        if (fit) {
          items = [fit].concat(items.filter(function (p) { return p !== fit; }));
          hint = '<div class="bt-cart-hint">💡 Добави <b>' + esc(fit.title.split(' ').slice(0, 3).join(' ')) + '</b> (' + money(fit.price) +
            ') – и доставката става <b>безплатна</b></div>';
        }
      }

      el.innerHTML = '<div class="bt-up__h">' + esc(c.title || 'Добави към поръчката') + '</div>' + hint +
        '<div class="bt-up__track">' + items.map(function (p) {
          var off = p.compare > p.price;
          return '<div class="bt-up__card">' +
            '<a class="bt-up__im" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(img(p.image)) + '" alt="" loading="lazy" width="150" height="150">' : '') + '</a>' +
            '<a class="bt-up__t" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            '<div class="bt-up__b"><span class="bt-up__p' + (off ? ' is-sale' : '') + '">' + money(p.price) + (off ? ' <s>' + money(p.compare) + '</s>' : '') + '</span>' +
            '<button type="button" class="bt-up__add" data-bt-add="' + p.variant + '" aria-label="Добави ' + esc(p.title) + '">' + esc(c.button || '+ Добави') + '</button></div>' +
            '</div>';
        }).join('') + '</div>';
    });
  }

  function scan() {
    document.querySelectorAll('[data-bt-upsell]:not([data-bt-ready])').forEach(render);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  // cart drawer-ът се прерисува при всяка промяна – попълваме новия контейнер
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
